var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResetLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19627)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4025 13.8421L23.7886 7.95728L25.4115 9.44262L20.0115 15.3426C20.0006 15.3546 19.9893 15.3663 19.9779 15.3778C19.974 15.3816 19.9727 15.3837 19.9727 15.3838L19.9725 15.3841C19.9724 15.3844 19.9707 15.3895 19.9716 15.3997C19.9724 15.4105 19.9757 15.4217 19.9804 15.4308C19.9843 15.4384 19.9874 15.4411 19.9874 15.4411L20.0056 15.456L26.1056 20.556L24.6945 22.2439L18.602 17.1501C17.6482 16.3768 17.4277 14.8402 18.4025 13.8421Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9182 19.8941C31.4263 14.5514 24.8909 12.6073 19.1463 14.5583L19.8538 16.6414C24.7076 14.993 30.1703 16.6473 33.079 21.1013L33.079 21.1014L33.0848 21.11C36.5443 26.2993 35.0897 33.4181 29.8899 36.8846C24.6899 40.3512 17.5799 38.9777 14.1201 33.697L14.1202 33.697L14.1153 33.6897C11.2004 29.3174 11.7465 23.5713 15.1167 19.8368L13.4834 18.3629C9.45445 22.8274 8.79994 29.6791 12.2823 34.9064C16.4235 41.2226 24.9113 42.8477 31.1102 38.7151C37.3089 34.5826 39.055 26.1044 34.9182 19.8941Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2,
    height: 33,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResetLight);
export default __webpack_public_path__ + "static/media/icon_reset_light.8f29444c.svg";
export { ForwardRef as ReactComponent };